import { useEffect, useState, memo } from 'react';
import SangerPrimerRowColor from './SangerPrimerRowComponents.js/SangerPrimerRowColor';
import SangerPrimerRowName from './SangerPrimerRowComponents.js/SangerPrimerRowName';
import SangerPrimerRowVol from './SangerPrimerRowComponents.js/SangerPrimerRowVol';
import Grid from '@material-ui/core/Grid';
import SanegrPrimerRowErrors from './SangerPrimerRowComponents.js/SangerPrimerRowErrors';
import IconButton from '@mui/material/IconButton';
import RemoveCircle from '@mui/icons-material/RemoveCircle';

const SangerPrimerRowComponent = (props) => {
    const data = props.data;
    const id = props.id;
    const primerKey= props.primerKey
    const index = props.index;
    const updatePrimerMap = props.updatePrimerMap;
    const removePrimer = props.removePrimer;
    const primers= props.primers
    const primerColors= props.primerColors;
    const primerMapToList= props.primerMapToList;
    const removeSample = props.removeSample;
    const addNewSampleIndex = props.addNewSampleIndex;
    const submitShowError = props.submitShowError;
    const showAllErrors = props.showAllErrors;
    const formik = props.formik;
    const reactCount = props.reactCount;

    return (
            <Grid container style={{paddingRight: 10, paddingLeft: 5, margin:0}}>
            <SangerPrimerRowColor
            data={data}
            primerColors={primerColors}
            primerKey={primerKey}
            id={id}
            />
            <SangerPrimerRowName
            data={data}
            showAllErrors={showAllErrors}
            submitShowError={submitShowError}
            updatePrimerMap={updatePrimerMap}
            primerKey={primerKey}
            id={id}
            />
            <SangerPrimerRowVol
            data={data}
            showAllErrors={showAllErrors}
            submitShowError={submitShowError}
            updatePrimerMap={updatePrimerMap}
            primerKey={primerKey}
            id={id}
            />
            <Grid item>
            <IconButton onClick={() => removePrimer(primerKey)}>
            <RemoveCircle/>
            </IconButton>
            </Grid>
            <SanegrPrimerRowErrors
            data={data}
            showAllErrors={showAllErrors}
            submitShowError={submitShowError}
            updatePrimerMap={updatePrimerMap}
            primerKey={primerKey}
            formik={formik}
            index={index}
            reactCount={reactCount}
            id={id}
            />
        </Grid>
    );
    }

export default SangerPrimerRowComponent;
